import React, { useState, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { useSnackbar } from "notistack";

import { Label, CheckBox, CheckType } from "../../../primitives";
import styles from "./styles.module.scss";
import { gskOptionCountries as defaultCountries } from "../../../../common/constants";
import { sortCountries } from "../../../../common/helper";
import {
  companyGetFilters,
  setFilters,
} from "modules/companies/companyMain/companyMain.action";

const StepThreeComponent = (props) => {
  const { handleOnSubmit } = props;
  const [select, setSelect] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(true);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const {
    councilReducer: { selectedCouncil },
    authReducer: { session },
    companiesReducer: {
      companyMainReducer: { industries },
    },
  } = useSelector((state) => state);

  useEffect(() => {
    const new_project = localStorage.getItem("new_project");
    const obj = JSON.parse(new_project);
    if (!obj.stage_template_id.obj[0].patient_organization) {
      dispatch(
        companyGetFilters({
          userId: session.id,
          councilId: selectedCouncil.id,
          enqueueSnackbar,
        })
      );
      const new_project = localStorage.getItem("new_project");
      const obj = JSON.parse(new_project);
      setSelect(obj.industrys);
    } else {
      const new_project = localStorage.getItem("new_project");
      const obj = JSON.parse(new_project);
      setSelect(obj.countries);

      if (!obj.countries.length) {
        onCheckChange(true, true);
      }
    }
  }, []);

  const onCheckChange = (val, item) => {
    const new_project = localStorage.getItem("new_project");
    const obj = JSON.parse(new_project);
    if (
      selectedCouncil.traction_tag === "gsk" &&
      obj.stage_template_id.obj[0].patient_organization
    ) {
      if (item) {
        if (item === "all") {
          if (val) {
            setSelect((prev) => [
              ...defaultCountries.map((country) => country.id),
            ]);
          } else {
            setSelect([]);
          }
        } else if (item && val) {
          setSelect((prev) => [...prev, item.id]);
          dispatch(
            setFilters({
              country_ids: select,
            })
          );
        } else {
          setIsAllSelected(false);
          setSelect((prev) => prev.filter((id) => id !== item.id));
          dispatch(
            setFilters({
              country_ids: select,
            })
          );
        }
      } else if (val) {
        if (!select.find((obj) => obj.id === item.id))
          setSelect((prev) => [...prev, item.id]);
        dispatch(
          setFilters({
            country_ids: select,
          })
        );
      } else {
        setSelect((prev) => prev.filter((id) => id !== item.id));
        dispatch(
          setFilters({
            country_ids: select,
          })
        );
      }
    } else if (val) {
      if (!select.find((obj) => obj.id === item.id))
        setSelect((prev) => [...prev, item.id]);
      dispatch(
        setFilters({
          industry_ids: select,
        })
      );
    } else {
      setSelect((prev) => prev.filter((id) => id !== item.id));
      dispatch(
        setFilters({
          industry_ids: select,
        })
      );
    }
  };

  useEffect(() => {
    const new_project = localStorage.getItem("new_project");
    let obj = JSON.parse(new_project);
    if (
      selectedCouncil.traction_tag === "gsk" &&
      obj.stage_template_id.obj[0].default_patient_organization
    ) {
      obj = { ...obj, countries: select };
      setIsAllSelected(select.length === defaultCountries.length);
    } else {
      obj = { ...obj, industrys: select?.filter(s => s) || [] };
    }

    localStorage.setItem("new_project", JSON.stringify(obj));
  }, [Object.keys(select)]);

  const getSelected = useCallback(
    (id) => select.find((key) => key === id),
    [select]
  );

  useEffect(() => {
    const new_project = localStorage.getItem("new_project");
    const obj = JSON.parse(new_project);
    if (
      selectedCouncil.traction_tag === "gsk" &&
      obj.stage_template_id.obj[0].default_patient_organization
    ) {
      if (isAllSelected) {
        setSelect(defaultCountries.map((el) => el.id));
      }
    }
  }, [isAllSelected]);

  const onSubmit = (values) => {
    handleOnSubmit(values);
  };

  const filteredTags = () => {
    const new_project = localStorage.getItem("new_project");
    const obj = JSON.parse(new_project);
    if (
      selectedCouncil.traction_tag === "gsk" &&
      obj.stage_template_id.obj[0].default_patient_organization
    ) {
      return defaultCountries.sort(sortCountries);
    }
    return industries.sort((a, b) => a.name.localeCompare(b.name));
  };

  return (
    <div className={styles.inner}>
      <h4 className={classNames("bold", styles.innerTitle)}>
        {selectedCouncil.traction_tag === "gsk" &&
        JSON.parse(localStorage.getItem("new_project")).stage_template_id
          ?.obj[0].patient_organization
          ? "Choose Country"
          : "Choose Industries"}
      </h4>
      <div className={classNames("bold", styles.infoText)}>
        {selectedCouncil.traction_tag === "gsk" &&
        JSON.parse(localStorage.getItem("new_project")).stage_template_id
          ?.obj[0].patient_organization
          ? "Use these country tags to generate a list of organizations for your project\n" +
            "        to address."
          : "Use these industry tags to generate a list of companies for your project\n" +
            "        to address."}
      </div>
      {filteredTags()[0] ? (
        <div className={styles.listWrp}>
          {/* <div className={styles.formElement}> */}
          {selectedCouncil.traction_tag === "gsk" &&
          JSON.parse(localStorage.getItem("new_project")).stage_template_id
            ?.obj[0].patient_organization ? (
            <div>
              <CheckBox
                checkType={CheckType.BLUE}
                isChecked={isAllSelected}
                onChange={(val) => onCheckChange(val, "all")}
              />
              <Label>
                <div className={classNames(styles.tagStyle)}>Select All</div>
              </Label>
            </div>
          ) : (
            ""
          )}
          {/* </div> */}
          {filteredTags().map((item) => (
            <div key={item.id} className={styles.formElement}>
              <div className="d-flex align-items-center">
                <CheckBox
                  checkType={CheckType.BLUE}
                  isChecked={getSelected(item.id)}
                  onChange={(val) => onCheckChange(val, item)}
                />
                <div className={classNames(styles.tagStyle)}>
                  <Label>{item.name}</Label>
                </div>
              </div>
              {item.children_industries && item.children_industries?.length
                ? item.children_industries.map((child) => (
                    <div
                      key={child.id}
                      className="pl-3 mt-2 d-flex align-items-center"
                    >
                      <CheckBox
                        checkType={CheckType.BLUE}
                        isChecked={getSelected(child.id)}
                        onChange={(val) => onCheckChange(val, child)}
                      />
                      <Label>
                        <div className={classNames(styles.tagStyle)}>
                          {child.name}
                        </div>
                      </Label>
                    </div>
                  ))
                : null}
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.noOptions}>
          There are no industries in this council to choose from.
        </div>
      )}
    </div>
  );
};

export default React.memo(StepThreeComponent);
